import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import { stateSelector } from '../../services/store';
import './style.css';

class Livescore extends Component {
  state = {
    attention: false,
  }

  componentDidUpdate(prevProps) {
    if (prevProps.score !== this.props.score) {
      this.setState({ attention: true }, () => {
        setTimeout(() => {
          this.setState({ attention: false });
        }, 2000);
      });
    }
  }

  render() {
    const { score, currentChapter } = this.props;
    const { attention } = this.state;

    return (
      <div className="livescore">
        <div className="livescore__content">
          <div className="livescore__label">{currentChapter}</div>
          <div
            className={cx('livescore__number', {
              'livescore__number--high': score > 590,
              'livescore__number--low': score <= 590,
            })}
          >
            <div className={cx({ bounce: attention })}>{score}</div>
          </div>
        </div>
      </div>
    );
  }
}

Livescore.propTypes = {
  score: PropTypes.number.isRequired,
  currentChapter: PropTypes.string,
};

export default connect(stateSelector)(Livescore);



// WEBPACK FOOTER //
// ./src/components/Livescore/index.js